import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import FormRadio from '../FormRadio/FormRadio';
import * as FormUtils from '../utils';

import './FormRadioButtonGroup.scss';

class FormRadioButtonGroup extends React.Component {
  static propTypes = {
    theme: PropTypes.string,
    inputAttributes: PropTypes.shape({
      name: PropTypes.string,
      isNonBinaryGenderEnabled: PropTypes.bool,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          textPrimary: PropTypes.string,
          textSecondary: PropTypes.string,
          value: PropTypes.string,
          qaTag: PropTypes.string,
        }),
      ),
    }),
    formik: PropTypes.object,
  };

  renderRadioButton = (props, index) => {
    props.name = this.props.inputAttributes.name;
    props.theme = this.props.theme;
    props.isNonBinaryGenderEnabled = this.props.inputAttributes.isNonBinaryGenderEnabled;
    return <FormRadio key={index} {...props} />;
  };

  render() {
    const { theme, inputAttributes, formik } = this.props;
    const fieldClasses = createBEM('Form__radioButtonGroup', {
      [theme]: !!theme,
      error: FormUtils.shouldShowError(formik, inputAttributes.name),
      nonBinary: inputAttributes.isNonBinaryGenderEnabled,
    });
    return (
      <div className={fieldClasses} role='radiogroup' aria-label={inputAttributes.name}>
        {inputAttributes.options.map(this.renderRadioButton)}
      </div>
    );
  }
}

export default formikConnect(FormRadioButtonGroup);
